// 🎁 Combos de la tienda en línea (negocios.tienda_combos, sql/137): "3 por L 399".
// Aplica a las piezas cuyo precio (oferta o normal) es exactamente `precioPieza` y,
// si hay categorías, solo a esas. Mismo cálculo que aplicar_combos_pedido en la BD:
// la bolsa lo muestra antes y el pedido se guarda con ese mismo precio.
import { precioEfectivo } from './precios';

const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0; };
const redondear = (n) => Math.round(n * 100) / 100;

export const nombreCombo = (c, simbolo = 'L') => `${c.cantidad} por ${simbolo} ${Number(c.precio).toLocaleString('en')}`;

export function normalizarCombo(c, simbolo) {
  const o = c && typeof c === 'object' ? c : {};
  const combo = {
    activo: o.activo !== false,
    cantidad: Math.min(10, Math.max(2, Math.trunc(num(o.cantidad)) || 3)),
    precio: num(o.precio),
    precioPieza: num(o.precioPieza),
    categorias: Array.isArray(o.categorias) ? o.categorias.filter((x) => typeof x === 'string' && x).slice(0, 30) : [],
    hasta: typeof o.hasta === 'string' && o.hasta ? o.hasta : null,
  };
  combo.nombre = nombreCombo(combo, simbolo);
  return combo;
}

export function normalizarCombos(cfg, simbolo) {
  const lista = cfg && Array.isArray(cfg.combos) ? cfg.combos : [];
  return { combos: lista.slice(0, 5).map((c) => normalizarCombo(c, simbolo)) };
}

// ¿Se puede usar? (activo, bien escrito, que de verdad ahorre y sin vencer).
export function comboValido(c, ahora = new Date()) {
  if (!c || !c.activo) return false;
  if (!(c.cantidad >= 2 && c.cantidad <= 10 && c.precio > 0 && c.precioPieza > 0)) return false;
  if (c.precio >= c.cantidad * c.precioPieza) return false;
  if (c.hasta && ahora > new Date(c.hasta)) return false;
  return true;
}

export const combosVigentes = (cfg, ahora = new Date(), simbolo) => normalizarCombos(cfg, simbolo).combos.filter((c) => comboValido(c, ahora));

export const entraEnCombo = (p, c) => Math.abs(precioEfectivo(p) - c.precioPieza) < 0.005
  && (!c.categorias.length || c.categorias.includes(p.categoria));

// Aplica los combos a las líneas de la bolsa. Devuelve las líneas con su
// subtotal final, el ahorro total y, por combo, cuántas veces se aplicó y
// cuántas piezas faltan para el siguiente (para animar a completar).
export function aplicarCombos(lineas, combos) {
  const out = lineas.map((l) => ({ ...l, combo: null }));
  const resumen = [];
  let ahorro = 0;
  combos.forEach((c) => {
    const unit = redondear(c.precio / c.cantidad);
    const elegibles = out.filter((l) => !l.combo && entraEnCombo(l.producto, c))
      .sort((a, b) => a.cantidad - b.cantidad || String(a.id).localeCompare(String(b.id)));
    const unidades = elegibles.reduce((s, l) => s + l.cantidad, 0);
    let slots = Math.floor(unidades / c.cantidad) * c.cantidad;
    let usadas = 0;
    elegibles.forEach((l) => {
      if (slots > 0 && l.cantidad <= slots) {
        l.combo = c.nombre;
        l.subtotal = redondear(unit * l.cantidad);
        ahorro += l.cantidad * (c.precioPieza - unit);
        slots -= l.cantidad; usadas += l.cantidad;
      }
    });
    const veces = usadas / c.cantidad;
    const faltan = unidades > 0 ? c.cantidad - (unidades % c.cantidad) : c.cantidad;
    resumen.push({ combo: c, veces, unidades, faltan: faltan === c.cantidad ? 0 : faltan });
  });
  return { lineas: out, ahorro: redondear(ahorro), resumen };
}
